const a = {
  "main-navigation": "main-navigation"
};
export {
  a as default
};
